import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-manage-repair-types',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-repair-types.component.html',
    styleUrl: './manage-repair-types.component.scss'
})
export class ManageRepairTypesComponent {
  repairData: any = [];
  exportData: any = [];
  newRepairName = '';
  ListingPriority = 0;
  isLoading: boolean = false;
  errorData: boolean = false;
  SaveSuccess: boolean = false;

  constructor(private adminService: AdminService, private commonService: CommonService, private messageService: NotificationService) {
    this.isLoading = true;
    this.setRepairData();
  }

  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }
  setRepairData() {
    this.adminService.getAllUserInteractions('ManageRepairTypes').subscribe((response: any) => {
      this.repairData = response;
      this.setExportData(response);
      this.processData();
    });
  };

  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      RepairName: item.RepairTypeName,
      RepairTypePriority: item.RepairTypePriority,
      RepairRetired: item.RepairTypeRetired
    }));
  }

  processData() {
    this.repairData.forEach((repair: any) => {
      if (repair.RepairTypeRetired == 'True') {
        repair.status = 'Inactive';
        repair.buttonName = 'Unretire'
      } else {
        repair.status = 'Active';
        repair.buttonName = 'Retire'
      }
    });
    this.isLoading = false;
  }

  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

      let payload = {
        "region": "RepairType",
        "recID": row.RecID,
        "retired": row.RepairTypeRetired == 'True' ? false : true
      }
      this.adminService.RETIREUSERINTERACTION(payload).subscribe({
        next: (message: any) => {
          this.messageService.showSuccess(message.message);
          this.setRepairData();
        }
      })
    }
  }
  onInput(event: any): void {
    const input = event.target;
    if (input.value.length > 3) {
      input.value = input.value.slice(0, 3);
      this.ListingPriority = input.value;
    }
  }
  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-RepairTypes.xlsx','TLRAdmin-RepairTypes');
    this.messageService.showSuccess("file downloaded successfully");
  }

  addRepair() {
    this.errorData = false;
    this.SaveSuccess = false;
    if (this.newRepairName == '' || this.ListingPriority == 0) {
      this.errorData = true;
      this.messageService.showError("Please fill all the fields");
      return;
    }
    let payload = {
      region: "RepairType",
      data: {
        RepairTypeName: this.newRepairName,
        RepairTypePriority: Number(this.ListingPriority),
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }

    this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.messageService.showSuccess(message);
        this.newRepairName = '';
        this.ListingPriority = 0;
        this.setRepairData();
      }
    })
  }
}
